export default __webpack_public_path__ + "static/media/boxIcon.4681cd8d.svg";